import { render } from "./Notification.vue?vue&type=template&id=6c42f8ce&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=6c42f8ce&scoped=true&lang=css"

import exportComponent from "D:\\CRUD Vue\\Puma Hammasi\\adidas-maincopy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c42f8ce"]])

export default __exports__